import type { FC } from "react";

import { Flex, Heading } from "src/components";
import { useTranslation } from "src/translations";
import { Controls, OutagesTable, TableAnnotation } from "./containers";

export type DashboardProps = Readonly<{}>;

export const Dashboard: FC<DashboardProps> = () => {
    const { t } = useTranslation();

    return (
        <Flex flexDirection="column" gap="2rem">
            <Flex flexDirection="row" justifyContent="space-between" flexWrap="wrap" gap="1rem">
                <Heading level={1}>{t("dashboard.title")}</Heading>
                <Controls />
            </Flex>
            <OutagesTable />
            <TableAnnotation />
        </Flex>
    );
};
